import { Link } from "react-router-dom";
import styles from "./LearningModules.module.css";

const library = [
  {
    href: "/egitim-modulleri/cocuklarda-sivi-elektrolit-tedavisi",
    evidence: "AAP + WHO 2025 + AHA/AAP PALS 2025 + SSC 2026",
    title: "Sıvı ve Elektrolit Tedavisi",
    summary: "Fizyolojiyi klinik karar, açıklamalı hesaplama, güvenli sıvı order’ı ve 15 hastalığa özgü protokolle birleştiren etkileşimli eğitim paketi.",
    tags: ["sıvı tedavisi", "elektrolit", "idame"],
    meta: "Katmanlı eğitim",
  },
  {
    href: "/egitim-modulleri/cocukta-zor-hava-yolu-ve-basarisiz-entubasyon",
    evidence: "AHA/AAP 2025 + ERC 2025 + RCH + AIDAA 2025 + DAS",
    title: "Zor Hava Yolu ve Başarısız Entübasyon",
    summary: "Anatomik ve fizyolojik zor hava yolunun tanınması, entübasyon öncesi hazırlık, başarısız girişimden sonra oksijenlenmenin korunması, supraglottik hava yolu ve CICO yönetimi için ileri eğitim modülü.",
    tags: ["zor hava yolu", "başarısız entübasyon", "oksijenlenme"],
    meta: "25 dk",
  },
] as const;

export function LearningModulesIndex() {
  return <main className={styles.indexPage}>
    <section className={styles.indexHero}>
      <div className={styles.shell}>
        <p className={styles.eyebrow}>İleri düzey klinik eğitim</p>
        <div className={styles.heroRow}>
          <div><h1>Eğitim Modülleri</h1><p>Çocuk acil ve çocuk yoğun bakım ekipleri için karar basamaklarını, ekip uygulamalarını, kontrol listelerini ve simülasyon hedeflerini bir araya getiren kapsamlı eğitim modülleri.</p></div>
          <div className={styles.counter}><strong>2</strong><span>İçerik</span></div>
        </div>
      </div>
    </section>
    <section className={`${styles.shell} ${styles.indexBody}`}>
      <div className={styles.featureGrid}>
        <Link to={library[0].href}><span>15 modül · etkileşimli klinik eğitim</span><h2>Çocuklarda Sıvı ve Elektrolit Tedavisi</h2><p>Fizyolojiden klinik karara, açıklamalı hesaplamadan güvenli hasta başı order’ına uzanan bütünlüklü eğitim paketi.</p></Link>
        <Link to="/ozel-durumlarda-resusitasyon"><span>15 bölümlük ileri eğitim dizisi</span><h2>Özel Durumlarda Resüsitasyon</h2><p>Travma, boğulma, hipotermi, toksikolojik arrest, kardiyak cerrahi sonrası arrest ve diğer özel durumlarda standart pediatrik resüsitasyon yaklaşımının nasıl uyarlanacağını inceleyin.</p></Link>
      </div>
      <header className={styles.libraryHeading}><p className={styles.eyebrow}>İçerik kütüphanesi</p><h2>Eğitim Modülleri içerikleri</h2></header>
      <div className={styles.libraryGrid}>{library.map((item) => <Link className={styles.libraryCard} key={item.href} to={item.href}>
        <div><span>Eğitim Modülü</span><small>{item.evidence}</small></div><h3>{item.title}</h3><p>{item.summary}</p>
        <ul>{item.tags.map((tag) => <li key={tag}>{tag}</li>)}</ul><footer><span>{item.meta}</span><strong>İçeriği görüntüle →</strong></footer>
      </Link>)}</div>
    </section>
  </main>;
}
